export default {
  defaultTexts: {
    CANCEL_BUTTON: 'Cancel',
    CONTINUE_BUTTON: 'Next',
    TRANSITION_BUTTON: 'Upload your bill instead',
    COMPLIANCE_DISCLOSURE: "We use your information (such as name and address) for verifying your eligibility. We record certain usage data for security, support, and reporting purposes. <a href='https://enervee.com/privacy' target='_blank'>See how your data is managed.</a>",
    FINISH_BUTTON: 'Finish Verification',
  },
};
